export function dateFormatShortMonthAndDay(date: Date) {
  const month = 'short' as const
  const day = 'numeric' as const
  const options = { month, day }
  return date.toLocaleDateString('en-US', options)
}

export function dateFormatShortMonthAndDayAndYear(date: Date) {
  const month = 'short' as const
  const day = 'numeric' as const
  const year = 'numeric' as const
  const options = { day, month, year }
  return date.toLocaleDateString('en-US', options)
}

export function dateFormatDefault(date: Date) {
  const options = {
    day: 'numeric' as const,
    month: 'numeric' as const,
    year: 'numeric' as const,
    hour: 'numeric' as const,
    minute: 'numeric' as const,
  }
  return date.toLocaleDateString('en-US', options)
}
